<template>
  <van-nav-bar
      title="准操项目"
      left-text="返回"
      right-text="添加"
      left-arrow
      @click-left="onClickLeft"
      @click-right="onClickRight"
  />
  <van-list v-model:loading="loading" :finished="finished">
    <van-cell
        v-for="item in list"
        :key="item.id"
        :title="item.name"
        :label="moneyAll(item)"
    >
      <template #right-icon>
        <van-button icon="edit" text="编辑" size="mini"
                    plain type="success" @click="clickEvent(item)">
        </van-button>
      </template>
    </van-cell>
    <!--    <van-cell v-for="item in list" :key="item.id" :title="item.name" is-link value="修改" @click="clickEvent(item)">
        </van-cell>-->
  </van-list>

  <van-dialog
      @confirm="addSpeciesId"
      v-model:show="show"
      title="添加准操项目"
      show-cancel-button
  >
    <van-cell-group>
      <van-field
          v-model="ProjectName"
          required
          error
          label="准操项目名称"
          placeholder="请输入准操项目名称"
      />
      <van-field v-model="projectMoney"
                 type="digit"
                 required
                 error-message="请输入准操项目报名金额(新办)"
                 label="金额(新办)"/>
      <van-field v-model="projectMoneyOld"
                 type="digit"
                 required
                 error-message="请输入准操项目报名金额(复训)"
                 label="金额(复训)"/>
    </van-cell-group>
  </van-dialog>

  <!--  修改-->
  <van-dialog
      @confirm="updateSpeciesId"
      v-model:show="updateIsShow"
      title="修改准操项目"
      show-cancel-button
  >
    <template #title>
      <div style="display: flex;flex-direction: column;width: 100%;align-items: center;justify-content: center">
        <b>修改准操项目</b>
        <van-button size="mini" icon="delete" plain type="danger" @click="deleteTrainCourse"
                    text="点击删除准操项目"></van-button>
      </div>

    </template>
    <van-cell-group>
      <van-field
          v-model="nowSelectSpeciesId.name"
          required
          error
          label="准操项目名称"
          placeholder="请输入准操项目名称"
      />
      <van-field v-model="nowSelectSpeciesId.money"
                 type="digit"
                 required
                 error-message="请输入准操项目报名金额(新办)"
                 label="金额(新办)"/>
      <van-field v-model="nowSelectSpeciesId.moneyOld"
                 type="digit"
                 required
                 error-message="请输入准操项目报名金额(复训)"
                 label="金额(复训)"/>
    </van-cell-group>
  </van-dialog>
</template>

<script>
import {useRouter, useRoute} from "vue-router";
import {onMounted, reactive, ref, toRefs} from "vue";
import {Dialog, Notify} from "vant";
import axios from "../../api/http";

export default {
  name: "AddTrainCourse",
  setup() {
    const router = useRouter();
    const show = ref(false);
    const ProjectName = ref("");
    const projectMoney = ref(400);
    const projectMoneyOld = ref(400)
    const route = useRoute();

    function onClickLeft() {
      router.back();
    }

    const listDemo = reactive({
      list: [],
      loading: false,
      finished: false
    });

    function onClickRight() {
      show.value = true;
    }

    const getAllSpeciesId = () => {
      axios
          .get("/api/RegisterInfo/GetTrainCourse/id/" + +route.query.parent)
          .then(res => {
            listDemo.finished = true;
            listDemo.list = res.data;
          });
    };

    function addSpeciesId() {
      if (ProjectName.value === "" || ProjectName.value === undefined) {
        Notify({type: "danger", message: "准操项目名称不可为空"});
        return;
      }
      if (projectMoney.value === "" || projectMoney.value === undefined) {
        Notify({type: "danger", message: "准操项目金额(新办)不可为空"});
        return;
      }
      if (projectMoneyOld.value === "" || projectMoneyOld.value === undefined) {
        Notify({type: "danger", message: "准操项目金额(复训)不可为空"});
        return;
      }
      axios
          .post(
              "/api/addTrainInformation/addTrainCourse/" +
              ProjectName.value +
              "/parent/" +
              route.query.parent +
              "/money/" +
              projectMoney.value +
              "/moneyOld/" +
              projectMoneyOld.value
          )
          .then(res => {
            ProjectName.value = "";
            console.log(res.data);
            getAllSpeciesId();
          });
    }

    let nowSelectSpeciesId = ref({
      id: undefined,
      name: undefined,
      parent: undefined,
      money: undefined,
      moneyOld: undefined,
    })

    let updateIsShow = ref(false)

    function updateSpeciesId() {
      if (nowSelectSpeciesId.value.name === "" || nowSelectSpeciesId.value.name === undefined) {
        Notify({type: "danger", message: "准操项目名称不可为空"});
        return;
      }
      if (nowSelectSpeciesId.value.money === "" || nowSelectSpeciesId.value.money === undefined) {
        Notify({type: "danger", message: "准操项目金额(新办)不可为空"});
        return;
      }
      if (nowSelectSpeciesId.value.moneyOld === "" || nowSelectSpeciesId.value.moneyOld === undefined) {
        Notify({type: "danger", message: "准操项目金额(复训)不可为空"});
        return;
      }
      axios
          .post(
              "/api/addTrainInformation/updateTrainCourse/" +
              nowSelectSpeciesId.value.id +
              "/name/" +
              nowSelectSpeciesId.value.name +
              "/money/" +
              nowSelectSpeciesId.value.money +
              "/moneyOld/" +
              nowSelectSpeciesId.value.moneyOld
          )
          .then(res => {
            ProjectName.value = "";
            console.log(res.data);
            getAllSpeciesId();
          });
    }

    function clickEvent(speciesId) {
      nowSelectSpeciesId.value.id = speciesId.id;
      nowSelectSpeciesId.value.name = speciesId.name;
      nowSelectSpeciesId.value.parent = speciesId.parent;
      nowSelectSpeciesId.value.money = speciesId.money;
      nowSelectSpeciesId.value.moneyOld = speciesId.moneyOld
      updateIsShow.value = true;
    }

    function moneyAll(item) {
      return "【新办:" + item.money + "元】 | 【" + "复训:" + item.moneyOld + "元】"
    }

    function deleteTrainCourse() {
      if (nowSelectSpeciesId.value.id === "" || nowSelectSpeciesId.value.id === undefined) {
        Notify({type: "danger", message: "准操项目未找到,请重新编辑"});
        return;
      }
      Dialog.confirm({
        title: "删除警告",
        message: "是否确认删除【" + nowSelectSpeciesId.value.name + "】",
      }).then(() => {
        axios
            .post(
                "/api/addTrainInformation/deleteTrainCourse/" +
                nowSelectSpeciesId.value.id
            )
            .then(res => {
              console.log(res.data);
              updateIsShow.value = false
              nowSelectSpeciesId.value.id = undefined;
              nowSelectSpeciesId.value.name = undefined;
              nowSelectSpeciesId.value.parent = undefined;
              nowSelectSpeciesId.value.money = undefined;
              nowSelectSpeciesId.value.moneyOld = undefined
              getAllSpeciesId();
            });
      }).catch(() => {
        // on cancel
      });
    }

    onMounted(() => {
      getAllSpeciesId();
    });

    return {
      onClickLeft,
      onClickRight,
      router,
      ...toRefs(listDemo),
      addSpeciesId,
      show,
      ProjectName,
      projectMoney,
      clickEvent,
      updateSpeciesId,
      updateIsShow,
      nowSelectSpeciesId,
      moneyAll,
      projectMoneyOld,
      deleteTrainCourse,
    };
  }
};
</script>
